<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>
<div class="column">
  <h2>Pazienti globali - Numero di utenti</h2>
  <div style="display: inline-block" style="padding-left: 0vw; padding-top: 1vw">
    <ng-container *ngIf="doughnutChartData">
      <div class="chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas baseChart
                [data]="doughnutChartData"
                [options]="doughnutChartOptions"
                [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType"
                [colors]="colorsOptions">
        </canvas>
      </div>
    </ng-container>
  </div>
</div>
<div class = "column" style="padding-left: 1vw; padding-top: 5vw; display: inline-block;position: center">
  <table mat-table [dataSource]="elements" class="mat-elevation-z8">
    <!-- pathology Column -->
    <ng-container matColumnDef="pathology">
      <th mat-header-cell *matHeaderCellDef> Patologia </th>
      <td mat-cell *matCellDef="let element"> {{element.pathology}} </td>
      <td mat-footer-cell *matFooterCellDef> Total </td>
    </ng-container>
    <!-- number of patients Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef> Numero di pazienti </th>
      <td mat-cell *matCellDef="let element"> {{element.number}} </td>
      <td mat-footer-cell *matFooterCellDef> {{totalPatients}} </td>
    </ng-container>
    <!-- pathology Description Column -->
    <ng-container matColumnDef="item-description">
      <th mat-header-cell *matHeaderCellDef> Name of Pathology </th>
    </ng-container>
    <!-- number of patients Description Column -->
    <ng-container matColumnDef="cost-description">
      <th mat-header-cell *matHeaderCellDef> Number of patients </th>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="headElements"></tr>
    <tr mat-row *matRowDef="let row; columns: headElements;"></tr>
    <tr mat-footer-row *matFooterRowDef="headElements"></tr>
  </table>
</div>
